"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLLanguage = void 0;
const filter_1 = __importDefault(require("lodash/filter"));
const EnumUtils_1 = require("../utils/native/EnumUtils");
var MOLLanguage;
(function (MOLLanguage) {
    MOLLanguage["ENGLISH"] = "EN";
    MOLLanguage["MANDARIN"] = "ZH";
    MOLLanguage["MALAY"] = "MS";
    MOLLanguage["TAMIL"] = "TA";
})(MOLLanguage || (exports.MOLLanguage = MOLLanguage = {}));
(function (MOLLanguage) {
    MOLLanguage.fn = {
        keys: EnumUtils_1.EnumUtils.keysFunc(MOLLanguage),
        values: EnumUtils_1.EnumUtils.valuesFunc(MOLLanguage),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(MOLLanguage),
        toEnumValue: (value) => {
            const toEnumValueFunc = EnumUtils_1.EnumUtils.toEnumValueFunc(MOLLanguage);
            const enumValue = toEnumValueFunc(value);
            if (enumValue) {
                return enumValue;
            }
            // Attempt to match key as well
            const enumKeys = (0, filter_1.default)(Object.keys(MOLLanguage), (val) => typeof val === "string");
            const foundIndex = enumKeys.findIndex((key) => key.toUpperCase() === (value === null || value === void 0 ? void 0 : value.toUpperCase()));
            return foundIndex >= 0 ? MOLLanguage[enumKeys[foundIndex]] : undefined;
        },
    };
})(MOLLanguage || (exports.MOLLanguage = MOLLanguage = {}));
//# sourceMappingURL=MOLLanguage.js.map